import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Input, TemplateRef } from '@angular/core';
import { Store } from '@ngrx/store';
import { OrderService, AuthenticationService, ShipmentService, ScannerService, JobService } from '../../../services';

// import {  COMMENT, QUEUED, PRINTED, PREPRESS } from '../../../../ngrx/status-types';
// import {  SET_ORDER_DETAILS_VIEW, SET_JOB_DETAILS_VIEW } from '../../../../ngrx/actions';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { SET_JOB_DETAILS_VIEW, SET_SHIPMENT_DETAILS_VIEW } from 'ngrx/actions';
import { HOLD, SHIPMENTS, READY, ID_CARD, ACCESSORY, CUT } from 'ngrx/status-types';
import { Subscription, Observable } from 'rxjs';
import { ActivityHistory, Job, Shipment } from 'app/models';

import { accessories, accessoryImage } from 'ngrx/material-type';
import { SHEETS } from 'ngrx/category-types';

@Component({
  selector: 'accessory-modal',
  templateUrl: 'accessory-modal.component.html',
  styleUrls:   ['accessory-modal.component.scss']
})
export class AccessoryModal implements OnInit, OnDestroy {
  @ViewChild('qaOkayFullModal') qaOkayFullModal  : TemplateRef<any>;
  @ViewChild('scanIdModal')     scanIdModal      : TemplateRef<any>;
  @ViewChild('wrongScanIdModal') wrongScanIdModal      : TemplateRef<any>;
  @ViewChild('orderErrorModal') orderErrorModal  : TemplateRef<any>;
  @Input('jobs')      jobs;
  @Input('shipment')  shipment;
  @Input('order')     order;
  @Input('isMTOAccessory')     isMTOAccessory;
  holdJobValueSubscr  : Subscription;
  getShipmentListSubscr: Subscription;
  process             : Observable<string>;
  jobHoldForm         : FormGroup;
  jobsCheck           : any = [];
  accessoriesCheck    : any = [];
  jobsAccessoryOkay          : boolean = false;
  disableHoldSubmit   : boolean = true;
  isAdmin             : boolean;
  isSupervisor        : boolean;
  math                = Math;
  category            : string;
  accessories         : any;
  accessoryImage      : any;
  shipmentList        : Observable<Shipment[]>;
  initSubscriptions   : Subscription[]; 
  orderErrorModalRef  : BsModalRef;
  orderError          : boolean = false;
  scanError           : boolean = false;
  scanQty             : number = 0;

  constructor(
    private authService      : AuthenticationService,
    private orderService     : OrderService,
    private shipmentService  : ShipmentService,
    private fb               : FormBuilder,
    private store            : Store<any>,
    private translate        : TranslateService,
    private modalService     : BsModalService,
    private scanner          : ScannerService,
    private jobService       : JobService
  ) {
    this.shipmentList    = this.shipmentService.getShipmentList();
    this.process         = this.authService.getCurrentProcess();
    this.isAdmin         = this.authService.userIsAdmin();
    this.accessories     = accessories;
    this.accessoryImage  = accessoryImage;
    this.isSupervisor    = this.authService.userIsSupervisor();
  }
  
  ngOnInit(): void {
    this.resetJobChecks();
    this.setHoldFormValues();
    this.accessoryChecked();
    this.initSubscriptions = [
      this.process.subscribe(process => {
        this.category = process;
      }),
      this.scanner
      ._accessoryScanListener
      .subscribe(id => {
        const ID       = id.replace(/[^A-Za-z0-9_]/g, '');
        const ACCESSORY_CODE       = ID.split('_')[0];
        const QTY                  = Number(ID.split('_')[1]);
        const [ l, t ] = this.scanner._triggers;
        const location = this.scanner._locations[l];
        console.log(`ACCESORRY CODE ${ID} scanned at ` + location);
        if(location === ACCESSORY || location === CUT) {
          if(this.jobsAccessoryOkay) {
            if(this.category == 'sheets'){
            }
          } else {
            let orderJobFound = false;
            for(let i = 0; i < this.accessoriesCheck.length; i++) {
              let currentAccessory = this.accessoriesCheck[i];
              console.log("currentAccessory", currentAccessory)

              if( currentAccessory && currentAccessory.accessory == ACCESSORY_CODE && !currentAccessory.accessoryChecked && this.orderError === false && this.scanError === false) {
                orderJobFound = true;
                let maxScanQty = currentAccessory.qty * 2; //Used as max validator
                

                //if scanned accessory matches qty the ordered qty then check it off
                //else increment into a variable to hold onto the count at instance lvl
                if(QTY && (QTY >= maxScanQty)){
                  //LOGIC FOR SCANNING WAY OVER THE NEEDED QTY
                  this.scanError = true;
                  this.orderErrorModalRef = this.modalService.show(this.orderErrorModal, {
                    animated: false,
                    class : 'modal-lg'
                  });``
                }else{
                  if(currentAccessory.scanQty < currentAccessory.qty) {
                    QTY ? currentAccessory.scanQty += Number(QTY) : currentAccessory.scanQty += Number(0);

                    if(currentAccessory.scanQty >= maxScanQty){
                      this.scanError = true;
                      currentAccessory.scanQty -= Number(QTY);
                      this.orderErrorModalRef = this.modalService.show(this.orderErrorModal, {
                        animated: false,
                        class : 'modal-lg'
                      });``
                    }else{
                      if(currentAccessory.scanQty >= currentAccessory.qty){
                        this.accessoriesCheck[i].accessoryChecked = true;
                      }

                    }
                  }
                }
                this.accessoryChecked();
                break;
              } 
            }
            

            //TO-DO : LOGIC FOR SCANNING WRONG ACESSORY
            if(orderJobFound === false) {
              if(this.scanError == false) {
                console.log("ORDER ERROR")
                this.scanError = true;
                this.orderErrorModalRef = this.modalService.show(this.orderErrorModal, {
                  animated: false,
                  class : 'modal-lg'
                });``
              }
            }
          }
        }
      })
    ]
  }

closeModal(): void {
  this.orderErrorModalRef.hide();
  this.scanError = false;
  this.orderError = false;
}

  ngOnDestroy(): void {
    console.log("Destroying...");
    this.holdJobValueSubscr.unsubscribe();
    this.initSubscriptions.forEach(subscription => subscription.unsubscribe());
  }
  
  jobAccessoryUpdate(id){
    this.jobs.forEach((job, idx) => {
      if(id == this.accessoriesCheck[idx].id && this.accessoriesCheck[idx].accessoryChecked){
        const updatedJob = Object.assign({}, job, { accessoryCheck: true });
        this.orderService.updateJob(updatedJob);
      }
    })
  }

  accessoryChecked() {
    let accessoryOkay = true;
    for(let i = 0; i < this.accessoriesCheck.length; i++) {
        if(this.accessoriesCheck[i] != null && !this.accessoriesCheck[i].accessoryChecked) {
          accessoryOkay = false;
          break;
        }
    }
    this.jobsAccessoryOkay = accessoryOkay;
  }

  setHoldFormValues() {
    this.jobHoldForm = this.fb.group({
      holdJobs       : this.fb.array([])
    });

    const jobList = this.jobs.map(job => this.fb.group({
      hold       : [false],
      id         : [job.id],
      holdReason : [''],
    }));

    this.jobHoldForm.setControl('holdJobs', this.fb.array(jobList, this.jobsValidator));
    this.holdJobOnChanges();
    this.disableHoldSubmit = true;
  }

  get holdJobs(): FormArray {
    return this.jobHoldForm.get('holdJobs') as FormArray;
  };

  resetJobChecks() {
    this.accessoriesCheck = [];

    this.jobs.forEach((job)=>{
      let accessoryChecked = (this.isAdmin || this.isSupervisor )? true : false;

      if(this.accessories[job.product.sku]) {
        let description : any = this.translate.instant(this.accessories[job.product.sku]);
        let accessory = description.split(' ')[0];

        console.log("🚀 ~ file: accessory-modal.component.ts:263 ~ AccessoryModal ~ this.jobs.forEach ~ description:", description)
        let qty = job.qty;
        // TBD: 80 or 20?
        if(accessory.includes('X2820003')) {
          let total_tags = qty * (+job.oaDetails.template.labels_per_sheet);
          qty = Math.ceil(total_tags/80) // Packs of 80?
        };
        console.log("🚀 ~ file: accessory-modal.component.ts:264 ~ AccessoryModal ~ this.jobs.forEach ~ qty:", qty)


        this.accessoriesCheck.push({
          id: job.id, 
          accessoryChecked: accessoryChecked,
          sku: job.product.sku, 
          accessory: accessory, 
          qty, 
          description: this.accessories[job.product.sku],
          scanQty : accessoryChecked ? qty : 0
        })
      } else {
        console.log(job)
        this.accessoriesCheck.push(null);
      }
    });
    console.log("this.accessoriesCheck : ", this.accessoriesCheck);
    this.setHoldFormValues();
  }

  jobsValidator(control: AbstractControl): any {
    let valid = false;
    control['controls'].forEach(formControl => {
      if (formControl.value.hold) {
        valid = true;
      }
    });

    return valid ? null: { atLeastOneSelected: false };
  }

  holdJobOnChanges() {
    this.holdJobValueSubscr = this.jobHoldForm.valueChanges.debounceTime(300).subscribe(val => {
      let disableHoldSubmit = true;
      for(let i = 0; i < val.holdJobs.length; i++) {
        let job = val.holdJobs[i];
        if(job.hold === true) {
          if(job.holdReason === null || job.holdReason.match(/^ *$/) !== null) {
            disableHoldSubmit = true;
            break;
          } else {
            disableHoldSubmit = false;
          }
        } else {
          this.holdJobs.at(i).patchValue({
            holdReason : '',
          });
        }
      }
      this.disableHoldSubmit = disableHoldSubmit;
    });
  }

  holdOrderAndJobs(event: Event): void {
    event.stopPropagation();
    this.store.dispatch({
      type: SET_SHIPMENT_DETAILS_VIEW,
      payload: { loading: true }
    });

    this.jobHoldForm.get('holdJobs').value.forEach(job => {
      if(job.hold && (job.holdReason !== null || job.holdReason.match(/^ *$/) === null)) {

        const jobToUpdate = this.jobs.filter(fullJob => fullJob.id === job.id)[0];
        this.orderService.setJobStatus(
          jobToUpdate,
          HOLD,
          this.translate.instant('Missing Accessory'),// this.translate.instant(this.changeHoldReason),
          undefined,
          job.holdReason
        );
      }
    });

    this.modalService.hide(1);
  }

  setShipmentReady(id): void {
    // event.stopPropagation();
    const currentUser = this.authService.getCurrentUser();
    const user = currentUser.substring(0, currentUser.indexOf('@'));
    let activity: ActivityHistory;
    if(this.category && this.shipment) {
      activity = {
        activity  : "Accessory Ok",
        //note      : this.isAdmin ? 'QA OK done - Admin override' : "Employee ID: " + id,
        note      : this.isAdmin ? `Accesory OK done - Admin override (Employee ID: ${user})` : "Employee ID: " + user,
        user      : this.authService.getCurrentUser(),
        timestamp : (new Date).getTime().toString(),
        comment   : null,
      };
    
      if(this.shipment.activity_history && Array.isArray(this.shipment.activity_history)) {
        this.shipment.activity_history.unshift(activity);
      } else {
        this.shipment.activity_history = [activity]
      }
      // if(this.layout === 'oa' && this.order && this.order.jobs.length === 1 && this.jobs[0].qty < 26) {
      //   this.shipment.
      // }
      this.shipmentService.accessoryCheckOK(this.shipment);
      this.modalService.hide(1);
    }
    // this.getShipmentListSubscr = this.shipmentList.subscribe(shipments => { 
         
    //   let activity: ActivityHistory;
    //   if(this.category == SHEETS) {
    //     activity = {
    //       activity  : "qa Ok",
    //       //note      : this.isAdmin ? 'QA OK done - Admin override' : "Employee ID: " + id,
    //       note      : this.isAdmin ? `Accesory OK done - Admin override (Employee ID: ${id})` : "Employee ID: " + id,
    //       user      : this.authService.getCurrentUser(),
    //       timestamp : (new Date).getTime().toString(),
    //       comment   : null,
    //     };
    //   } 
    //   if(this.shipment.activity_history && Array.isArray(this.shipment.activity_history)) {
    //     this.shipment.activity_history.push(activity);
    //   } else {
    //     this.shipment.activity_history = [activity]
    //   }
    //   // if(this.layout === 'oa' && this.order && this.order.jobs.length === 1 && this.jobs[0].qty < 26) {
    //   //   this.shipment.
    //   // }
    //   this.shipmentService.accessoryCheckOK(this.shipment);
    //   this.modalService.hide(1);
     
    // })
    // this.getShipmentListSubscr.unsubscribe();
  }

    
  setJobReady(): void {
    // PACKING -> SHIPPING FOR MTO CARDS
    this.orderService.setJobStatus(
      this.jobs[0],
      'shipping',
      null,
      undefined,
      null
    );
    this.modalService.hide(1);
  }
}



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/shared/modals/accessory-modal/accessory-modal.component.ts